import React from 'react';
import { MyPageContainer } from 'components/atoms';

const ContainerForm: React.FC = ({ children }) => {
  return <MyPageContainer>{children}</MyPageContainer>;
};

export default ContainerForm;
